import Vue from 'vue'
import Index from './index.vue'
import store from '@/store/store'
require('@/resource/js/global_public');//需要引入公共js(包含GLOBAL、rem、analysis)

new Vue({
    el: '#app',
    render: h => h(Index),
    store
})


// WEBPACK FOOTER //
// ./src/pages/index/index.js